import "es6-promise/auto";
import "babel-polyfill";
import "url-search-params-polyfill";
import "css-vars-ponyfill";
// import "ie11-custom-properties";

import Vue from "vue";
import App from "./App.vue";

// Import vuetify
import vuetify from "./plugins/vuetify";

//Import our store folder, in store/index.js we set up out state management
import store from "./store";

//Router allows us to navifay
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./registerServiceWorker";

//Charts
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);

//SVG Nonsense
import InlineSvg from "vue-inline-svg";
Vue.component("InlineSvg", InlineSvg);

Vue.use(VueAxios, axios);
Vue.use(require("vue-moment"));

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// console.log(" -- Environment Variables");
// console.log(process.env);

axios.defaults.baseURL = process.env.VUE_APP_CATERPOINT + "/housekeeping/restapi/";

axios.defaults.prodImagesURL = process.env.VUE_APP_CATERPOINT + "/images/prods/";

//Check if we're still Authorised
axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response.status == 401) {
      store.dispatch("setSnackbar", {
        color: "error",
        text: "Unauthorized - You can only sign in on one device at a time",
      });

      store.dispatch("userSignoutAction");
      router.push({ name: "Welcome" });
    }
    return Promise.reject(error);
  }
);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
